import React from 'react';
import '../Css/Additional.css';

const Additional = () => {
  // Data for the cards
  const cardData = [
    { name: 'Website Designing & Development'},
    { name: 'Android App Development'},
    { name: 'IOS App Development'},
    { name: 'Logo & Graphics Designing'},
    { name: 'Web Portal & Development'},
    { name: 'Device Inegration'},
    { name: 'Custom Web Development'},
    { name: 'API Inegration'},
    
    



    // { name: 'EMMA JOHNSON', number: '3333 333 333 3333', validity: 'VALID', expiry: '04/31' },
    // { name: 'EMMA JOHNSON', number: '3333 333 333 3333', validity: 'VALID', expiry: '04/31' },
    // { name: 'EMMA JOHNSON', number: '3333 333 333 3333', validity: 'VALID', expiry: '04/31' },
    // { name: 'EMMA JOHNSON', number: '3333 333 333 3333', validity: 'VALID', expiry: '04/31' },
    

  ];

  return (
    <>
    <div class="outer_container_x my-3 row gap-3">
    <h1 className='text-center text-light'>Additional Development</h1>
      {cardData.map((cardadd, index) => (
         <div class="container_x">
             <div  key={index} class="box_2">
               <span class="text-md title">{cardadd.name}</span>
               <div>
                 <strong></strong>
                 <p>{cardadd.validity}</p>
                 {/* <span>VALID</span> <span>{cardadd.expiry}</span> */}
               </div>
             </div>
           </div>
    ))}
    </div>
    
    {/* <div className="container-add">
    {cardData.map((cardadd, index) => (
     <div className="cards-add-container">
        {/* Mapping over card data to generate cards */}
          {/* <div key={index} className="box-add">
            <span className="title-add">GLASS EFFECT</span>
            <div>
              <strong>{cardadd.name}</strong>
              <p>{cardadd.number}</p>
              <span>{cardadd.validity}</span> <span>{cardadd.expiry}</span>
            </div>
          </div>
      </div> */}
    
    {/* ))} */}
    {/* </div> */} 
    
    </>
    
  );
};

export default Additional;

